import React from "react";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { ReactComponent as BsInfoCircleFill } from "../../../../../assets/Icons/Universal/BsInfoCircleFill.svg";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import CustomBill from "../../../../../components/Universal/CustomBill.component";
import VendorPaymentValidation from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/MaterialAndResources/VendorPaymentValidation.component";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";
import "../../../../../styles/Pages/Financial/CashOutFlow/AcademicEx/MaterialAndResources.style.css";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import HistoryTable from "../../../../../components/PagesComponents/UniversalComponents/HistoryTable.component";

const materials = [
  {
    itemCode: "MAT001",
    item: "Chalk",
    quantity: 150,
    unit: "box",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 100,
  },
  {
    itemCode: "MAT002",
    item: "Chair",
    quantity: 33,
    unit: "pcs",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 200,
  },
  {
    itemCode: "MAT003",
    item: "Duster",
    quantity: 130,
    unit: "pcs",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 50,
  },
  {
    itemCode: "MAT004",
    item: "Office file",
    quantity: 30,
    unit: "pcs",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 150,
  },
  {
    itemCode: "MAT005",
    item: "Chalk",
    quantity: 150,
    unit: "box",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 100,
  },
  {
    itemCode: "MAT006",
    item: "Chair",
    quantity: 33,
    unit: "pcs",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 200,
  },
  {
    itemCode: "MAT007",
    item: "Duster",
    quantity: 130,
    unit: "pcs",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 50,
  },
  {
    itemCode: "MAT008",
    item: "Office file",
    quantity: 30,
    unit: "pcs",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 150,
  },
  {
    itemCode: "MAT009",
    item: "Chalk",
    quantity: 150,
    unit: "box",
    date: "02 Oct, 2025",
    reporter: "Samiul Ittefak",
    unitPrice: 100,
  },
];

const historyTableData = [
  {
    date: "27 Dec, 2024",
    time: "10:24 AM",
    receiptId: "23457289056",
    items: [
      {
        name: "Chalk",
        quantity: 150,
        unit: "box",
        unitPrice: 18,
      },
      {
        name: "Duster",
        quantity: 33,
        unit: "pcs",
        unitPrice: 50,
      },
    ],
    totalAmount: 36000,
    paidAmount: 18000,
    paymentMethod: "UPI",
    vendor: {
      name: "Mahi Enterprise",
      phone: "9876543210",
    },
    confirmedBy: "Jaheer Ahmad",
    receipt: true,
    status: "Pay due",
  },
  {
    date: "27 Dec, 2024",
    time: "10:24 AM",
    receiptId: "23457289056",
    items: [
      {
        name: "Chalk",
        quantity: 150,
        unit: "box",
        unitPrice: 100,
      },
      {
        name: "Duster",
        quantity: 33,
        unit: "pcs",
        unitPrice: 1800,
      },
    ],
    totalAmount: 36000,
    paidAmount: 36000,
    paymentMethod: "Net banking",
    vendor: {
      name: "Mahi Enterprise",
      phone: "9876543210",
    },
    confirmedBy: "Jaheer Ahmad",
    receipt: true,
    status: "All paid",
  },
  {
    date: null,
    time: "10:24 AM",
    receiptId: "23457289056",
    items: [
      {
        name: "Chalk",
        quantity: 150,
        unit: "box",
        unitPrice: 800,
      },
      {
        name: "Duster",
        quantity: 33,
        unit: "pcs",
        unitPrice: 180,
      },
    ],
    totalAmount: 36000,
    paidAmount: 18000,
    paymentMethod: "Debit card",
    vendor: {
      name: "Mahi Enterprise",
      phone: "9876543210",
    },
    confirmedBy: "Jaheer Ahmad",
    receipt: true,
    status: "Pay due",
  },
  {
    date: null,
    time: "10:24 AM",
    receiptId: "23457289056",
    items: [
      {
        name: "Chalk",
        quantity: 150,
        unit: "box",
        unitPrice: 20,
      },
      {
        name: "Duster",
        quantity: 33,
        unit: "pcs",
        unitPrice: 120,
      },
    ],
    totalAmount: 36000,
    paidAmount: 18000,
    paymentMethod: "Cash",
    vendor: {
      name: "Mahi Enterprise",
      phone: "9876543210",
    },
    confirmedBy: "Jaheer Ahmad",
    receipt: true,
    status: "Receipt",
  },
  {
    date: "27 Dec, 2024",
    time: "10:24 AM",
    receiptId: "23457289056",
    items: [
      {
        name: "Chalk",
        quantity: 150,
        unit: "box",
        unitPrice: 60,
      },
      {
        name: "Duster",
        quantity: 33,
        unit: "pcs",
        unitPrice: 180,
      },
    ],
    totalAmount: 36000,
    paidAmount: 18000,
    paymentMethod: null,
    vendor: {
      name: "Mahi Enterprise",
      phone: "9876543210",
    },
    confirmedBy: "Jaheer Ahmad",
    receipt: true,
    status: "Pay due",
  },
];

const confirmedByOptions = ["Admin", "Finance Head", "CEO"];
const paymentModes = ["Cash", "UPI", "Bank Transfer", "Cheque"];

const Body = () => {
  const [isReceiptOpen, setIsReceiptOpen] = React.useState(false);
  const [checkedItems, setCheckedItems] = React.useState({});
  const [selectedData, setSelectedData] = React.useState([]);
  const [submittedValues, setSubmittedValues] = React.useState(null);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showHistory, setShowHistory] = React.useState(false);

  // New state for tax %
  const [taxPercent, setTaxPercent] = React.useState(10);

  const handleSelectAll = () => {
    const allSelected = Object.keys(checkedItems).length === materials.length;
    if (allSelected) {
      setCheckedItems({});
      setSelectedData([]);
    } else {
      const newChecked = {};
      // copy items so selectedData can be edited independently
      const newSelected = materials.map((item) => {
        newChecked[item.itemCode] = true;
        return { ...item };
      });
      setCheckedItems(newChecked);
      setSelectedData(newSelected);
    }
  };

  const handleSingleCheck = (itemCode, item) => {
    const updated = { ...checkedItems };
    const isChecked = !!updated[itemCode];

    if (isChecked) {
      delete updated[itemCode];
      setSelectedData((prev) => prev.filter((d) => d.itemCode !== itemCode));
    } else {
      updated[itemCode] = true;
      // add a copy so editing doesn't mutate original materials
      setSelectedData((prev) => [...prev, { ...item }]);
    }

    setCheckedItems(updated);
  };

  const handleUnitPriceChange = (itemCode, newPrice) => {
    setSelectedData((prev) =>
      prev.map((item) =>
        item.itemCode === itemCode
          ? { ...item, unitPrice: Number(newPrice) || 0 }
          : item
      )
    );
  };

  const subtotal = React.useMemo(() => {
    return selectedData.reduce(
      (acc, item) => acc + (Number(item.unitPrice) || 0) * (Number(item.quantity) || 0),
      0
    );
  }, [selectedData]);

  const taxAmount = React.useMemo(
    () => (subtotal * (Number(taxPercent) || 0)) / 100,
    [subtotal, taxPercent]
  );
  const netTotal = React.useMemo(() => subtotal + taxAmount, [subtotal, taxAmount]);

  if (showHistory)
    return (
      <section className="MaterialAndResourcesHistorySection">
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && (
            <CustomBill data={selectedData} vendorInfo={submittedValues} />
          )}
        </ScrollableModal>
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="All payments history, cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        </Helmet>

        <PageHeader title={"All payments history"} />

        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All material & resources payment history
            </h3>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input type="text" className="pageHeaderInput" placeholder="Search id" />
                </div>

                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>

              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowHistory(false)}
                  className="actionBtn"
                >
                  Go to material and resources
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>

          <HistoryTable historyTableData={historyTableData} setShowHistory={setShowHistory} />
        </div>
      </section>
    );

  return (
    <section className="MaterialAndResourcesSection">
      <ScrollableModal
        isOpen={isReceiptOpen}
        onClose={() => setIsReceiptOpen(!isReceiptOpen)}
      >
        {isReceiptOpen && (
          <CustomBill data={selectedData} vendorInfo={submittedValues} />
        )}
      </ScrollableModal>

      <Helmet>
        <title>Material & Resources</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="Material & Resources,cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <PageHeader title={"Material & Resources"} />

      <div className="MaterialAndResourceContaienr">
        <div className="left">
          <div className="table-header">
            <h3>
              List of all material & resources needed <BsInfoCircleFill />
            </h3>
            <button onClick={handleSelectAll}>
              {Object.keys(checkedItems).length === materials.length ? "Deselect All" : "Select All"}
            </button>
          </div>

          <div className="table-container scroll-y">
            <table className="material-table">
              <thead>
                <tr>
                  <th>Items</th>
                  <th>Order size</th>
                  <th>Need on</th>
                  <th>Reported by</th>
                  <th>Select</th>
                </tr>
              </thead>
              <tbody>
                {materials.map((mat) => (
                  <tr key={mat.itemCode}>
                    <td>{mat.item}</td>
                    <td>
                      {mat.quantity} {mat.unit}
                    </td>
                    <td>{mat.date}</td>
                    <td className="reporter">{mat.reporter}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!checkedItems[mat.itemCode]}
                        onChange={() => handleSingleCheck(mat.itemCode, mat)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="right">
          <div className="content-header">
            <h3>Confirmation of Payment</h3>
            {/* Restored All Payments History button */}
            <button onClick={() => setShowHistory(true)} className="blueActionBtnLight">
              All Payments History
            </button>
          </div>

          {showSuccess ? (
            <div className="billSuccess">
              <h2>You have confirm payment successfully</h2>
              <p>Receipt ID: 23456789012</p>
              <h4 onClick={() => setIsReceiptOpen(true)}>
                Receipt <BsBoxArrowRight />
              </h4>
              <button onClick={() => setShowSuccess(false)} className="actionBtn">
                Okay
              </button>
            </div>
          ) : (
            selectedData.length > 0 && (
              <>
                <div className="bill-table-container">
                  <table className="bill-table">
                    <thead>
                      <tr>
                        <th>Items({selectedData.length})</th>
                        <th>Order Size</th>
                        <th>Reported by</th>
                        <th>Amount (INR)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedData.map((item) => (
                        <tr key={item.itemCode}>
                          <td>{item.item}</td>
                          <td>
                            {item.quantity} {item.unit}
                          </td>
                          <td className="reporter">{item.reporter}</td>
                          <td>
                            <span className="totalAmount">
                              <span className="rupeeSymbol">₹</span>
                              <input
                                style={{
                                  outline: "none",
                                  border: "none",
                                  backgroundColor: "transparent",
                                  width: "80px",
                                  height: "24px",
                                }}
                                type="number"
                                value={item.unitPrice}
                                onChange={(e) => handleUnitPriceChange(item.itemCode, e.target.value)}
                              />
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="totalContainer">
                  <div className="subSection">
                    <div className="subTotal">
                      <span>Sub Total:</span>
                      <span>₹ {subtotal}</span>
                    </div>

                    <div className="taxes">
                      <span>Other tax (GST, SGST, CGST) in %</span>
                      <span className="taxPercentage">
                        <input
                          type="number"
                          value={taxPercent}
                          onChange={(e) => setTaxPercent(Number(e.target.value) || 0)}
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor: "transparent",
                            width: "40px",
                            height: "24px",
                          }}
                        />
                      </span>
                      <span>₹ {taxAmount}</span>
                    </div>
                  </div>

                  <div className="netTotal">
                    <span>Total:</span>
                    <span>₹ {netTotal}</span>
                  </div>
                </div>

                <div className="formContaienr">
                  <Formik
                    initialValues={{
                      vendorName: "",
                      vendorContact: "",
                      paidAmount: "",
                      confirmedBy: "",
                      paymentMode: "",
                    }}
                    validationSchema={VendorPaymentValidation}
                    onSubmit={(values) => {
                      console.log("Form Submitted:", values);
                      setSubmittedValues(values);
                      setShowSuccess(true);
                    }}
                  >
                    {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => (
                      <form onSubmit={handleSubmit} className="vendorPaymentForm">
                        <div className="vendorPaymentFormInputs">
                          <FormInput
                            label="Vendor name"
                            type="text"
                            name="vendorName"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor name"
                            setFieldValue={(e) => setFieldValue("vendorName", e.target.value)}
                          />

                          <FormInput
                            label="Vendor contact"
                            type="text"
                            name="vendorContact"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor contact number"
                            setFieldValue={(e) => setFieldValue("vendorContact", e.target.value)}
                          />

                          <FormInput
                            label="Paid amount (INR)"
                            type="number"
                            name="paidAmount"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter paid amount"
                            setFieldValue={(e) => setFieldValue("paidAmount", e.target.value)}
                          />

                          <DropDownInput
                            name="confirmedBy"
                            label="Confirmed by"
                            placeholder="Choose confirmed by"
                            suggestionList={confirmedByOptions}
                            setFieldValue={(val) => setFieldValue("confirmedBy", val)}
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) => setTouched({ [name]: isTouched })}
                          />

                          <DropDownInput
                            name="paymentMode"
                            label="Payment mode"
                            placeholder="Choose payment mode"
                            suggestionList={paymentModes}
                            setFieldValue={(val) => setFieldValue("paymentMode", val)}
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) => setTouched({ [name]: isTouched })}
                          />
                        </div>

                        <button type="submit" className="confirmPaymentBtn actionBtn">
                          Confirm payment
                        </button>
                      </form>
                    )}
                  </Formik>
                </div>
              </>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
